<template>
  <div class="title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: "MainTitle",
  props: {
    title: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  max-width: fit-content;
  width: 100%;
  height: 93px;
  display: flex;
  align-items: center;
  justify-content: center;
  @include font("CeraPro", 74px, 700);
}

@media screen and (max-width: 900px) {
  .title {
    font-size: 54px;
  }
}

@media screen and (max-width: 600px) {
  .title {
    font-size: 44px;
  }
}
</style>
